<script lang="ts" setup>
  type Props = {
    main: string
    secondary?: string
    promo?: boolean
  }

  const props = defineProps<Props>()
</script>
<template>
  <div
    class="c-card-top-infos"
    :class="{promo: props.promo}"
  >
    <div class="main">
      <span>{{ props.main }}</span>
    </div>
    <div
      v-if="props.secondary"
      class="secondary"
    >
      <span>{{ props.secondary }}</span>
    </div>
  </div>
</template>
<style scoped>

.c-card-top-infos {
  position: absolute;
  z-index: 1;
  top: 0;
  display: flex;
  overflow: hidden;
  flex-direction: row;
  align-items: center;
  border-radius: 4px;

  .main {
    display: flex;
    height: 100%;
    align-items: center;
    padding: 0.25em 0.5em;
    background-color: var(--color-grey-dark);

    span {
      color: white;
      font-family: Open-Sans, sans-serif;
      font-size: 0.875em;
      font-weight: 600;
    }
  }

  .secondary {
    display: flex;
    height: 100%;
    align-items: center;
    padding: 0.25em;
    background-color: var(--color-secondary-light);

    span {
      color: var(--color-grey-dark);
      font-family: Open-Sans, sans-serif;
      font-size: 0.875em;
      font-weight: 600;
    }
  }

  &.promo {
    .main {
      background-color: var(--color-promo);
    }
  }
}
</style>
